export const Input = (props) => {
  const { value, input, type, placeholder, className, label, disabled, maxLength, tabIndex, autoFocus, autoComplete, min, max } = props;
  // console.log("input", input); // onChange value
  return (
    <div className={className}>
      <label>{label}</label>
      <input
        type={type}
        disabled={disabled}
        autoComplete={autoComplete}
        maxLength={maxLength}
        placeholder={placeholder}
        value={value}
        tabIndex={tabIndex}
        autoFocus={autoFocus}
        {...input}
        min={min}
        max={max}
      />
    </div>
  );
};
